import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-steps-banner',
    templateUrl: './steps-banner.component.html',
    styleUrls: ['./steps-banner.component.scss'],
    standalone: false
})
export class StepsBannerComponent implements OnInit {

  @Input() activeStep: number = 0
  @Input() isSoseMode: boolean = false
  @Output() loginClicked: EventEmitter<any> = new EventEmitter<any>()

  isLoggedIn: boolean = false
  currentLang: string = 'en'

  constructor(public translateService: TranslateService) {

    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
    });
  }

  ngOnInit(): void {


  }

}
